export class CleanCacheRequest { 
    public idProject: number[] = [];
    public idHealthUnit: number[] = [];
}